const requiredUrl = (value, name) => {
  if (!value) throw new Error(`Missing ${name}`);
  return value;
};

// Keep the intake form and conversational agent as separate public destinations.
export const ACTIVATION_URL = requiredUrl(
  process.env.REACT_APP_JOTFORM_INTAKE_URL,
  "REACT_APP_JOTFORM_INTAKE_URL"
);

export const RHEA_URL = requiredUrl(
  process.env.REACT_APP_JOTFORM_RHEA_URL,
  "REACT_APP_JOTFORM_RHEA_URL"
);
